import { ShieldCheck } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useTranslationV2 } from '@/hooks/useTranslationV2';

export function DealerVerificationBadge() {
  const { t } = useTranslationV2('navigation');
  return <Tooltip>
    <TooltipTrigger asChild>
      <span tabIndex={0} className="inline-flex items-center gap-1.5 rounded-full border border-accent/30 bg-accent/20 px-2.5 py-1 text-[11px] font-semibold text-foreground">
        <ShieldCheck className="h-3 w-3" aria-hidden="true" />{t('dealer_verified_label')}
      </span>
    </TooltipTrigger>
    <TooltipContent>{t('dealer_verification_tooltip')}</TooltipContent>
  </Tooltip>;
}